<template>
  <v-layout wrap>
    <v-flex>
      <Table
        table-title="Templates"
        :headers="headers"
        :items="templates"
        icon="file_copy"
        :actions="actions"
        :items-per-page="20"
        primaryActionText="New Template"
        primaryActionIcon="add"
        @primary-action-event="gotoNewTemplate"
      ></Table>
    </v-flex>
  </v-layout>
</template>

<script>
import Table from "@/components/Table";
import request from "@/modules/request";
import { get } from "lodash";
import moment from "moment";

export default {
  name: "UserTemplates",
  components: {
    Table,
  },
  inject: ["reactiveInjected"],
  async mounted() {
    await this.getTemplates();
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: "Created At",
          value: "createdAt",
        },
        {
          text: "",
          value: "action",
        },
      ],
      templates: [],
      actions: [
        {
          color: "primary",
          click: this.viewTemplate,
          text: "View",
        },
      ],
    };
  },
  methods: {
    gotoNewTemplate() {
      this.$router.push({
        name: "UserCreateTemplate",
      });
    },
    async getTemplates() {
      const results = await request.callInternal({
        method: "get",
        route: `/api/templates`,
      });

      this.templates = results.data.map((template) => {
        template.createdAt = moment(template.createdAt).format("MM-DD-YYYY");
        return template;
      });
    },
    viewTemplate(template) {
      this.$router.push({
        name: "UserTemplate",
        params: {
          id: template._id,
        },
      });
    },
  },
};
</script>
